import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../utils/api';

const MetalRatesContext = createContext();

export function MetalRatesProvider({ children }) {
  const [metalRates, setMetalRates] = useState([]);

  const fetchRates = useCallback(async () => {
    try {
      const res = await api.get('/metal-rates');
      setMetalRates(res.data || []);
    } catch (err) {
    }
  }, []);

  useEffect(() => {
    // Fetch initial rates via API
    fetchRates();

    // Connect to SSE for real-time updates
    const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
    let eventSource = null;
    let sseConnected = false;

    const connectSSE = () => {
      eventSource = new EventSource(`${backendUrl}/api/kerala-bullion/rate-stream`);

      eventSource.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          if (data.rates && data.rates.length > 0) {
            setMetalRates(data.rates);
            sseConnected = true;
          }
        } catch (err) {
        }
      };

      eventSource.onerror = () => {
        sseConnected = false;
        // Browser auto-reconnects EventSource, but we track connection state
      };

      eventSource.onopen = () => {
        sseConnected = true;
      };
    };

    connectSSE();

    // Fallback polling every 2 minutes (only fires if SSE is disconnected)
    const pollInterval = setInterval(() => {
      if (!sseConnected) {
        fetchRates();
      }
    }, 120000);

    return () => {
      if (eventSource) eventSource.close();
      clearInterval(pollInterval);
    };
  }, [fetchRates]);

  return (
    <MetalRatesContext.Provider value={{ metalRates, refreshRates: fetchRates }}>
      {children}
    </MetalRatesContext.Provider>
  );
}

export const useMetalRates = () => useContext(MetalRatesContext);
